module.exports = __webpack_public_path__ + "static/media/blueradio.132fd5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/blueradio.png
// module id = 548
// module chunks = 0